import { useEffect, useState, useMemo } from "react";
import { useCookies } from "react-cookie";
import useWebSocket from "react-use-websocket";
import { useCallback } from 'react';

const socketUrl = "wss://brmm0q8jaa.execute-api.eu-central-1.amazonaws.com/production";

export function useCashRegisterSettings() {
  const [cookies] = useCookies(["secret", "station", "staff", "staffName"]);
  const [pin, setPin] = useState(false);


  const { login, logout, ping, state } = useAuthCookie()
  console.log({ state: state })
  const handleLogin = ({ pin }) => setPin(pin);
  const handleLogout = () => setPin(null);



  const { sendJsonMessage, lastJsonMessage } = useWebSocket(socketUrl, {
    queryParams: {
      station: cookies.station,
      secret: cookies.secret,
      staff: cookies.staff,
    },
    shouldReconnect: () => true,
    share: true,
  });

  const updatePin = useMemo(() => {
    return ({ pin: oldPin, newPin }) => {
      console.log('cashRegisterUserPinUpdate', oldPin, newPin)
      sendJsonMessage({
        task: "cashRegisterUserPinUpdate",
        station: cookies.station,
        staff: cookies.staff,
        pin: oldPin,
        newPin,
      });
    };
  }, [sendJsonMessage, cookies.station, cookies.staff]);


  const initSettings = {
    aclPermissions: null,
    crsClientId: null,
    crsStatus: "LOGGEDOUT",
    login: handleLogin,
    logout: handleLogout,
    updatePin,
    staffName: cookies.staffName
  };
  const [settings, setSettings] = useState(initSettings);

  // Memoized message sender (fires only once per hook instance)
  const requestSettings = useMemo(() => {
    return () => {
      if (state) {

        setSettings({
          ...state,
          login: handleLogin,
          logout: handleLogout,
          updatePin,
        });

        return;
      }
      sendJsonMessage({
        task: "cashRegisterClientSettings",
        station: cookies.station,
        staff: cookies.staff,
        pin
      });
    };
  }, [sendJsonMessage, state,  cookies.station, cookies.staff, pin]);



  // Send request on mount
  useEffect(() => {
    if(pin === false && state){
      ping();
      requestSettings();
    }
    if (pin !== false) {
      requestSettings();
    }
    if (pin === null) {
      setSettings(initSettings)
      logout();
    }
  }, [pin]);


  // Handle incoming message
  useEffect(() => {
    if (!lastJsonMessage) return;

    if (lastJsonMessage.task === "respCashRegisterClientSettings") {

      const staticSettings = {
        aclPermissions: lastJsonMessage.aclPermissions ?? {
          cpc: false,
          reg: false,
          stat: false,
          refund: false,
        },
        crsClientId: lastJsonMessage.crsClientId ?? null,
        crsStatus: lastJsonMessage.crsStatus ?? "PENDING",
        staffName: cookies.staffName,
      };

      login(staticSettings)

      setSettings({
        ...staticSettings,
        login: handleLogin,
        logout: handleLogout,
        updatePin,
      });
    }
  }, [lastJsonMessage]);

  return settings;
}




const COOKIE_KEY = 'auth';
const COOKIE_LIFETIME_MS = 10 * 60 * 1000; // 10 minutes

function useAuthCookie() {
  const [cookies, setCookie, removeCookie] = useCookies([COOKIE_KEY]);

  const login = useCallback((obj) => {
    const expires = new Date(Date.now() + COOKIE_LIFETIME_MS);
    console.log('sss')
    setCookie(COOKIE_KEY, JSON.stringify(obj), {
      path: '/',
      expires,
      sameSite: 'strict'
    });
  }, [setCookie]);

  const logout = useCallback(() => {
    removeCookie(COOKIE_KEY, { path: '/' });
  }, [removeCookie]);

  const ping = useCallback(() => {
    const val = cookies[COOKIE_KEY];
    if (!val) return;

    // Refresh expiration
    const expires = new Date(Date.now() + COOKIE_LIFETIME_MS);
    setCookie(COOKIE_KEY, val, {
      path: '/',
      expires,
      sameSite: 'strict'
    });
  }, [cookies, setCookie]);

  const state = cookies[COOKIE_KEY] ? cookies[COOKIE_KEY] : false;
      

  return { login, logout, ping, state };
}
